/**
 * Shared TFA constants. Single source of truth so subcomponents can import.
 */
import {
  FileText, ListChecks, Layers, PenLine, Presentation,
  Languages, HelpCircle, ClipboardList,
} from "lucide-react";

export const ARTIFACT_DEFS = [
  { key: "lesson_plan",  label: "Lesson plan",  icon: PenLine,      chip: "tb-chip-lavender" },
  { key: "quiz",         label: "Quiz",         icon: ListChecks,   chip: "tb-chip-mint" },
  { key: "worksheet",    label: "Worksheet",    icon: FileText,     chip: "tb-chip-butter" },
  { key: "flashcards",   label: "Flashcards",   icon: Layers,       chip: "tb-chip-rose" },
  { key: "homework",     label: "Homework",     icon: ClipboardList,chip: "tb-chip-sky" },
  { key: "ppt_outline",  label: "Presentation", icon: Presentation, chip: "tb-chip-lavender" },
  { key: "simplified",   label: "Simplified",   icon: HelpCircle,   chip: "tb-chip-mint" },
  { key: "translated",   label: "Translation",  icon: Languages,    chip: "tb-chip-butter" },
];

export const SUBJECTS  = ["Mathematics", "Science", "English", "Hindi", "Social Studies", "Physics", "Chemistry", "Biology", "Computer Science", "General"];
export const CURRICULA = ["CBSE", "ICSE", "IB", "Cambridge", "State board", "US", "UK", "General"];
export const LANGUAGES = ["English", "Hindi", "Kannada", "Tamil", "Telugu", "Marathi", "Bengali", "Arabic", "French", "Spanish"];
